package dev.valvassori.minesweeper.ext

inline fun <reified T> Array<Array<T>>.flattenAndFilter(predicate: (T) -> Boolean): Array<T> =
    flatten().filter(predicate).toTypedArray()
